import { EmptyState, NetworkIcon, Skeleton, formatUsd } from "@unizpay/ui";
import { Network } from "lucide-react";
import type { Overview } from "../../lib/types";

/** Settled volume per network as horizontal bars, largest first (the API orders them). */
export function VolumeByNetwork({ rows }: { rows: Overview["by_network"] | undefined }) {
  if (!rows) {
    return (
      <output aria-label="Loading" className="block space-y-4">
        {[0, 1, 2].map((i) => (
          <Skeleton key={i} className="h-8 w-full" />
        ))}
      </output>
    );
  }
  if (rows.length === 0) {
    return (
      <EmptyState icon={Network} title="No settled payments">
        Volume per network shows up once payments settle.
      </EmptyState>
    );
  }

  const max = Math.max(...rows.map((r) => Number(r.volume)), 0);
  return (
    <ul className="space-y-3.5">
      {rows.map((r) => (
        <li key={r.network}>
          <div className="flex items-baseline justify-between gap-3 text-[0.8125rem]">
            <span className="flex min-w-0 items-center gap-2">
              <NetworkIcon network={r.network} size={18} />
              <span className="truncate font-medium">{r.network_name}</span>
            </span>
            <span className="shrink-0 tabular-nums">
              {formatUsd(r.volume)}
              <span className="ml-1.5 text-xs text-fg-muted">
                {r.count} {r.count === 1 ? "payment" : "payments"}
              </span>
            </span>
          </div>
          <div aria-hidden="true" className="mt-1.5 h-1.5 rounded-full bg-subtle">
            <div
              className="h-full rounded-full bg-accent"
              style={{ width: `${max > 0 ? Math.max(2, (Number(r.volume) / max) * 100) : 0}%` }}
            />
          </div>
        </li>
      ))}
    </ul>
  );
}
